export default __webpack_public_path__ + "static/product11-1fc7167ca7cd399f85ab80dbb7be3da7.jpg";